import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Loader from "../../Components/Loader";

import "./style.scss";

const InvitedSignIn = () => {
  const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
  const [params] = useSearchParams();
  const queryParams = Object.fromEntries([...params]);
  const userName = queryParams.email || queryParams.phoneNumber;

  const navigate = useNavigate();
  useEffect(() => {
    if (ps10005000) {
      navigate("/sessions");
    } else {
      navigate(`/?userName=${encodeURIComponent(userName)}`);
    }
  }, [ps10005000, userName, navigate]);

  return <Loader />;
};

export default InvitedSignIn;
